import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiStar, FiTrendingUp, FiHeart, FiShoppingBag, FiZap } from 'react-icons/fi';

export default function CategoryCards({ onCategorySelect }) {
  const categories = [
    {
      id: 'standard-dress',
      name: 'Standard Dress',
      slug: 'standard-dress',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/10939f91-4-10.jpg',
      description: 'Classic standard dance dresses',
      icon: FiHeart,
      gradient: 'from-rose-500 to-pink-500',
      featured: false
    },
    {
      id: 'latin-dress',
      name: 'Latin Dress',
      slug: 'latin-dress',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/53bf9700-1-106.jpg',
      description: 'Passionate Latin dance dresses',
      icon: FiTrendingUp,
      gradient: 'from-red-500 to-pink-500',
      featured: true
    },
    {
      id: 'kids-wear',
      name: 'Kids Wear',
      slug: 'kids-wear',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/58a1f199-1-16.jpg',
      description: 'Adorable dance wear for kids',
      icon: FiHeart,
      gradient: 'from-green-400 to-blue-500',
      featured: false
    },
    {
      id: 'practice-wear',
      name: 'Practice Wear',
      slug: 'practice-wear',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/45526beb-4-48.jpg',
      description: 'Comfortable practice clothing',
      icon: FiShoppingBag,
      gradient: 'from-slate-500 to-gray-600',
      featured: false
    },
    {
      id: 'earrings',
      name: 'Earrings',
      slug: 'earrings',
      image: 'https://images.unsplash.com/photo-1693212793204-bcea856c75fe?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Beautiful earrings for performances',
      icon: FiZap,
      gradient: 'from-yellow-400 to-orange-500',
      featured: false
    },
    {
      id: 'hand-jewelry',
      name: 'Hand Jewelry',
      slug: 'hand-jewelry',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/O1CN013wpRn122uUXy65n7F__2212565967180-0-cib_jpg.jpg',
      description: 'Elegant hand jewelry pieces',
      icon: FiStar,
      gradient: 'from-blue-500 to-purple-500',
      featured: false
    },
    {
      id: 'head-jewelry',
      name: 'Head Jewelry',
      slug: 'head-jewelry',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/O1CN018RhSXQ22uUi1M5Jul__2212565967180-0-cib_jpg-600x600.jpg',
      description: 'Beautiful head jewelry and accessories',
      icon: FiStar,
      gradient: 'from-purple-500 to-pink-500',
      featured: false
    },
    {
      id: 'necklace',
      name: 'Necklace',
      slug: 'necklace',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/O1CN01aBcq5J1YGFYBHvOZu__2219501353031-0-cib_jpg.jpg',
      description: 'Elegant necklaces for dancers',
      icon: FiStar,
      gradient: 'from-indigo-500 to-purple-500',
      featured: false
    },
    {
      id: 'other-body-jewelry',
      name: 'Other Body Jewelry',
      slug: 'other-body-jewelry',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/O1CN01WXdmhg22uUUexLf8C__2212565967180-0-cib_jpg.jpg',
      description: 'Unique body jewelry pieces',
      icon: FiZap,
      gradient: 'from-violet-500 to-purple-500',
      featured: false
    },
    {
      id: 'shoes',
      name: 'Shoes',
      slug: 'shoes',
      image: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop&crop=center',
      description: 'Professional dance shoes',
      icon: FiShoppingBag,
      gradient: 'from-orange-500 to-red-500',
      featured: true
    },
    {
      id: 'accessories',
      name: 'Accessories',
      slug: 'accessories',
      image: 'https://images.unsplash.com/photo-1569388330292-79cc1ec67270?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Essential accessories for every dancer',
      icon: FiShoppingBag,
      gradient: 'from-purple-500 to-pink-500',
      featured: false
    },
    {
      id: 'jewelry',
      name: 'Jewelry',
      slug: 'jewelry',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/O1CN01JDsltv1YGFY8ueajh__2219501353031-0-cib_jpg-600x600.jpg',
      description: 'Complete jewelry collection',
      icon: FiZap,
      gradient: 'from-amber-400 to-yellow-500',
      featured: true
    },
    {
      id: 'dress',
      name: 'Dress',
      slug: 'dress',
      image: 'https://images.unsplash.com/photo-1591253368336-a4409e39df7b?q=80&w=880&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      description: 'Elegant dance dresses',
      icon: FiHeart,
      gradient: 'from-pink-500 to-rose-500',
      featured: false
    },
    {
      id: 'new-arrival',
      name: 'New Arrival',
      slug: 'new-arrival',
      image: 'https://shop.bailebelle.com/wp-content/uploads/2025/09/1_e3a68803-51d3-44d0-8006-e7a2a02795ea.jpg',
      description: 'Latest collection pieces',
      icon: FiTrendingUp,
      gradient: 'from-emerald-400 to-cyan-500',
      featured: false
    }
  ];

  const handleCategoryClick = (category) => {
    if (onCategorySelect) {
      onCategorySelect(category.slug);
    }
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-pink-900/20 via-purple-900/20 to-black"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: 'serif' }}>
              Our Collections
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
              Discover the perfect dance wear and jewelry for every performance
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400">
              <span className="px-4 py-2 bg-gray-800/50 rounded-full">Premium Quality</span>
              <span className="px-4 py-2 bg-gray-800/50 rounded-full">Handcrafted</span>
              <span className="px-4 py-2 bg-gray-800/50 rounded-full">Professional Grade</span>
            </div>
          </div>
        </div>
      </div>

      {/* Featured Categories */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Featured Collections
          </h2>
          <p className="text-gray-400 text-lg">
            Our most popular categories
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {categories.filter(cat => cat.featured).map((category) => {
            const IconComponent = category.icon;
            return (
              <div
                key={category.id}
                className="group relative overflow-hidden rounded-3xl transition-all duration-700 hover:scale-105 hover:shadow-2xl cursor-pointer"
                onClick={() => handleCategoryClick(category)}
              >
                <div className="relative h-80">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${category.gradient} opacity-60 group-hover:opacity-80 transition-opacity duration-300`} />
                  
                  {/* Featured Badge */}
                  <div className="absolute top-4 right-4">
                    <div className="px-3 py-1 bg-pink-500 text-white text-xs font-bold rounded-full">
                      Featured
                    </div>
                  </div>

                  {/* Category Info */}
                  <div className="absolute inset-0 flex flex-col justify-end p-8">
                    <div className="flex items-center mb-3">
                      <div className="p-2 bg-white/20 backdrop-blur-sm rounded-lg mr-3">
                        <IconComponent className="text-white" size={24} />
                      </div>
                      <h3 className="text-2xl font-bold text-white">
                        {category.name}
                      </h3>
                    </div>
                    <p className="text-white/90 text-sm mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {category.description}
                    </p>
                    
                    <div className="inline-flex items-center text-white font-semibold text-sm opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
                      Explore Collection
                      <FiArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={16} />
                    </div>
                  </div>

                  {/* Hover Effect Border */}
                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-white/50 rounded-3xl transition-all duration-300" />
                </div>
              </div>
            );
          })}
        </div>

        {/* All Categories */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            All Categories
          </h2>
          <p className="text-gray-400 text-lg">
            Browse our complete collection
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
          {categories.filter(category => {
            const allowedCategories = [
              'standard-dress',
              'latin-dress', 
              'kids-wear',
              'practice-wear',
              'earrings',
              'hand-jewelry',
              'head-jewelry',
              'necklace',
              'other-body-jewelry',
              'shoes',
              'accessories'
            ];
            return allowedCategories.includes(category.id);
          }).map((category) => {
            const IconComponent = category.icon;
            return (
              <div
                key={category.id}
                className="group relative overflow-hidden rounded-2xl transition-all duration-500 hover:scale-105 hover:shadow-xl cursor-pointer"
                onClick={() => handleCategoryClick(category)}
              >
                <div className="relative aspect-square">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${category.gradient} opacity-50 group-hover:opacity-70 transition-opacity duration-300`} />
                  
                  {/* Category Info */}
                  <div className="absolute inset-0 flex flex-col justify-end p-4">
                    <div className="text-center">
                      <div className="p-2 bg-white/20 backdrop-blur-sm rounded-lg w-fit mx-auto mb-2">
                        <IconComponent className="text-white" size={20} />
                      </div>
                      <h3 className="text-sm font-bold text-white mb-1 group-hover:text-pink-300 transition-colors">
                        {category.name}
                      </h3>
                    </div>
                  </div>

                  {/* Hover Effect Border */}
                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-white/30 rounded-2xl transition-all duration-300" />
                </div>
              </div>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-8 md:p-12">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Can't Find What You're Looking For?
            </h3>
            <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
              Our team is here to help you find the perfect dance wear and jewelry for your needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center px-8 py-4 bg-pink-600 text-white font-bold rounded-xl transition-all duration-300 hover:scale-105 shadow-xl hover:bg-pink-700"
              >
                Contact Us
                <FiArrowRight className="ml-2" size={20} />
              </Link>
              <Link
                to="/collections"
                className="inline-flex items-center px-8 py-4 border-2 border-gray-600 text-white font-bold rounded-xl transition-all duration-300 hover:scale-105 hover:border-pink-500"
              >
                View All Products
                <FiArrowRight className="ml-2" size={20} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
